import {
  connection,
  findRecord,
  updateRecord,
  insertRecord,
  transferMoney,
  sortArray,
} from "./services";

import { toJalaali } from "jalaali-js";

import { getTours as getTourMain } from "./adminTourList";

type reservationType = {
  id: number;
  mtm: string;
  total_pay_state: number;
  tour: {
    id: number;
    title: string;
    mainprice: number;
    main_status: number;
    stm: string;
    trasportType: string;
  };
  buyer: {
    id: number;
    fullname: string;
    mobile: string;
    codemelli: string;
    seat_number: string;
  };
  passangers: {
    id: number;
    fullname: string;
    mobile: string;
    codemelli: string;
    seat_number: string;
  }[];
  factor: {
    total_amt: number;
    total_count: number;
    total_discount: number;
    total_paid: number;
  };
  additionalCost: {
    id: number;
    title: string;
    cost: number;
    discount: number;
  }[];
};

async function getSeats(tourId: number): Promise<number[]> {
  let res: { seat_number: string }[];
  res = await findRecord("tour_reservation_items", {
    conditions: `tour_id/=/${tourId}@@main_state/!=/1`,
    fields: "seat_number",
    tbl_name: "",
  });
  return res.map((value) => parseInt(value.seat_number));
}

async function getModalInfo(): Promise<{
  users: {
    id: string;
    fname: string;
    lname: string;
    mobile: string;
    codemelli: string;
  }[];
  additionalCost: {
    id: string;
    title: string;
    cost: string;
    tour_id: string;
  }[];
}> {
  let res: any,
    data: {
      users: {
        id: string;
        fname: string;
        lname: string;
        mobile: string;
        codemelli: string;
      }[];
      additionalCost: {
        id: string;
        title: string;
        cost: string;
        tour_id: string;
      }[];
    } = {
      users: [],
      additionalCost: [],
    };
  res = await findRecord("users", {
    conditions: "mobile/!=/",
    fields: "id, fname, lname, mobile, codemelli",
    tbl_name: "",
  });
  data.users = res;
  res = await findRecord("tour_additional_cost", {
    tbl_name: "tours",
    conditions: "tours.main_status/in/2,4",
    fields:
      "tour_additional_cost.id, tour_additional_cost.title, tour_additional_cost.cost, tour_additional_cost.tour_id",
  });
  data.additionalCost = res.map(
    (value: { id: string; title: string; cost: string; tour_id: string }) => {
      return {
        ...value,
        cost: parseInt(value.cost),
      };
    }
  );

  return data;
}

async function getTourPassangers(tourId: number): Promise<{
  passangers: {
    id: string;
    fullname: string;
    mobile: string;
    seat_number: string;
  }[];
  isBus: boolean;
}> {
  let res: any = await findRecord("tour_reservation_items", {
    conditions: `tour_id/=/${tourId}`,
    fields: "uid, seat_number",
    tbl_name: "",
  });
  let seats: string[] = [],
    uids: number[] = res.map((value: { uid: string; seat_number: string }) => {
      seats.push(value.seat_number);
      return value.uid;
    });
  res = await findRecord("users", {
    conditions: `id/in/${uids.join(",")}`,
    fields: "id, fname, lname, mobile, codemelli",
    tbl_name: "",
  });
  let result: {
    passangers: {
      id: string;
      fullname: string;
      mobile: string;
      seat_number: string;
    }[];
    isBus: boolean;
  } = {
    passangers: [],
    isBus: false,
  };
  result.passangers = res.map(
    (
      value: {
        id: string;
        fname: string;
        lname: string;
        codemelli: string;
        mobile: string;
      },
      index: number
    ) => {
      return {
        id: value.id,
        fullname: `${value.fname} ${value.lname}`,
        seat_number: seats[index],
        mobile: value.mobile,
        codemelli: value.codemelli,
      };
    }
  );
  res = await findRecord("tour_other_field_values", {
    conditions: `tour_id/=/${tourId}@@code/=/8`,
    fields: "val",
    tbl_name: "",
  });
  result.isBus = res.length > 0 && res[0].val.includes("bus");
  console.log(res);
  console.log(res[0].val.includes("bus"));
  return result;
}

async function getTours(conditions = ""): Promise<
  {
    duration: string;
    id: string;
    main_status: string;
    mainprice: string;
    title: string;
    transferType: string;
    trasportType: string;
  }[]
> {
  let result: {
    duration: string;
    id: string;
    main_status: string;
    mainprice: string;
    title: string;
    transferType: string;
    trasportType: string;
  }[];
  if (conditions == "") conditions = "main_status/=/4";
  else conditions = "main_status/=/4@@" + conditions;
  let res: any = await getTourMain(conditions);
  result = res.map(
    (value: {
      duration: string;
      id: string;
      main_status: string;
      mainprice: string;
      title: string;
      transferType: string;
      trasportType: string;
    }) => {
      return {
        duration: value.duration,
        id: value.id,
        main_status: value.main_status,
        mainprice: value.mainprice,
        title: value.title,
        transferType: value.transferType,
        trasportType: "",
      };
    }
  );
  res = await findRecord("tour_other_field_values", {
    conditions: `code/=/8`,
    fields: "val, tour_id",
    tbl_name: "",
  });
  res.forEach((value: { val: string; tour_id: string }) => {
    let index = result.findIndex((val) => val.id == value.tour_id);
    if (index != -1) {
      result[index].trasportType = value.val;
    }
  });
  return result;
}

async function getReservation(uid = -1): Promise<reservationType[]> {
  let res: any, data: reservationType[];
  res = await findRecord("tour_additional_cost", {
    conditions: "",
    fields: "id, title, cost, tour_id",
    tbl_name: "",
  });
  let additionalCosts: {
    id: string;
    title: string;
    cost: string;
    tour_id: string;
  }[] = res;
  let conditions: { uid?: number } = {};
  if (uid != -1) conditions.uid = uid;
  res = await connection("findfactors", {
    ...conditions,
    conditions: "",
    fields: "",
    tbl_name: "",
  });
  type findfactorType = {
    buyer: {
      codemelli: string;
      fname: string;
      id: string;
      lname: string;
      mobile: string;
    };
    id: string;
    main_status: string;
    mainprice: string;
    mtm: string;
    muid: string;
    other_params: string;
    passanger: {
      codemelli: string;
      fname: string;
      id: string;
      lname: string;
      mobile: string;
    };
    stm: string;
    title: string;
    total_amt: string;
    total_count: string;
    total_discount: string;
    total_paid: string;
    total_pay_state: string;
    tour_id: string;
    uid: string;
    trasport_type: string;
    seat_number: string;
  };

  res = sortArray(res.res, "mtm");
  data = res.reduce((factors: reservationType[], factor: findfactorType) => {
    let facIndex = factors.findIndex(
      (val: reservationType) => val.id == parseInt(factor.id)
    );
    if (facIndex == -1) {
      let result: reservationType = {
        id: parseInt(factor.id),
        mtm: "",
        total_pay_state: parseInt(factor.total_pay_state),
        tour: {
          id: 0,
          main_status: 0,
          mainprice: 0,
          stm: "",
          title: "",
          trasportType: "",
        },
        buyer: {
          id: 0,
          codemelli: "",
          fullname: "",
          mobile: "",
          seat_number: "",
        },
        passangers: [],
        additionalCost: [],
        factor: {
          total_amt: 0,
          total_count: 0,
          total_discount: 0,
          total_paid: 0,
        },
      };
      try {
        let x = toJalaali(new Date(parseInt(factor.mtm) * 1000));
        result.mtm = `${x.jy}/${x.jm < 10 ? "0" : ""}${x.jm}/${
          x.jd < 10 ? "0" : ""
        }${x.jd}`;
      } catch (err) {
        result.mtm = "";
      }

      result.tour = {
        id: parseInt(factor.tour_id),
        title: factor.title,
        mainprice: parseInt(factor.mainprice),
        main_status: parseInt(factor.main_status),
        stm: "",
        trasportType: factor.trasport_type,
      };
      try {
        let x = toJalaali(new Date(parseInt(factor.stm) * 1000));
        result.tour.stm = `${x.jy}/${x.jm < 10 ? "0" : ""}${x.jm}/${
          x.jd < 10 ? "0" : ""
        }${x.jd}`;
      } catch (err) {}

      result.buyer = {
        id: parseInt(factor.buyer.id),
        fullname: `${factor.buyer.fname} ${factor.buyer.lname}`,
        mobile: factor.buyer.mobile,
        codemelli: factor.buyer.codemelli,
        seat_number: factor.seat_number,
      };

      if (factor.passanger.id != factor.buyer.id) {
        result.passangers = [
          {
            id: parseInt(factor.passanger.id),
            fullname: `${factor.passanger.fname} ${factor.passanger.lname}`,
            mobile: factor.passanger.mobile,
            codemelli: factor.passanger.codemelli,
            seat_number: factor.seat_number,
          },
        ];
      }

      result.factor = {
        total_amt: parseInt(factor.total_amt),
        total_count: parseInt(factor.total_count),
        total_discount: parseInt(factor.total_discount),
        total_paid: parseInt(factor.total_paid),
      };

      let additionalCost: { id: string; discount: string }[] = [];
      try {
        let temp = JSON.parse(factor.other_params).additional_costs;
        if (typeof temp !== "undefined") additionalCost = JSON.parse(temp);
      } catch (err) {}

      result.additionalCost = additionalCost.reduce(
        (
          tot: {
            id: number;
            title: string;
            cost: number;
            discount: number;
          }[],
          val
        ) => {
          let ac = additionalCosts.find((v) => v.id == val.id);
          if (typeof ac === "undefined") return tot;
          return [
            ...tot,
            {
              id: parseInt(ac.id),
              title: ac.title,
              cost: parseInt(ac.cost),
              discount: parseInt(val.discount),
            },
          ];
        },
        []
      );
      factors.push(result);
    } else {
      if (parseInt(factor.passanger.id) != factors[facIndex].buyer.id)
        factors[facIndex].passangers.push({
          id: parseInt(factor.passanger.id),
          fullname: `${factor.passanger.fname} ${factor.passanger.lname}`,
          mobile: factor.passanger.mobile,
          codemelli: factor.passanger.codemelli,
          seat_number: factor.seat_number,
        });
    }
    return factors;
  }, []);
  return data;
}

async function addUser(info: {
  fname: string;
  lname: string;
  mobile: string;
  codemelli: string;
}): Promise<number | false> {
  let res: any = await connection("adduser", {
    conditions: "",
    fields: "",
    tbl_name: "",
    fname: info.fname,
    lname: info.lname,
    mobile: info.mobile,
    codemelli: info.codemelli,
  });
  return res.status == 1 ? res.result.id : false;
}

async function saveReservation(
  data: {
    total_amt: number;
    total_paid: number;
    total_count: number;
    total_discount: number;
    buyer: {
      id: number;
      fname: string;
      lname: string;
      mobile: string;
      codemelli: string;
    };
    passangers: {
      id: number;
      fname: string;
      lname: string;
      mobile: string;
      codemelli: string;
    }[];
    seats: number[];
    tour_id: number;
    additionalCosts: any;
  },
  factor_id: number,
  userId: number
): Promise<boolean> {
  console.log(data.buyer);
  console.log(data.passangers);
  let res = await connection("savereservation", {
    conditions: "",
    fields: "",
    tbl_name: "",
    total_amt: data.total_amt,
    total_paid: data.total_paid,
    total_count: data.total_count,
    total_discount: data.total_discount,
    seats: data.seats.join(","),
    buyerId: data.buyer.id,
    passangersIds: data.passangers.map((value) => value.id).join(","),
    tour_id: data.tour_id,
    other_params: JSON.stringify({
      additional_costs: data.additionalCosts,
    }),
    factor_id,
    userId,
  });
  return res.status == 1;
}

async function cancelFactor(factorId: number): Promise<boolean> {
  let res = await connection("cancelfactor", {
    conditions: "",
    fields: "",
    tbl_name: "",
    factorId,
  });
  return res.status == 1;
}

async function payFactor(id: number, price: number) {
  connection("", {
    conditions: "",
    fields: "",
    tbl_name: "",
    factor_id: id,
    price,
  });
}

export {
  getSeats,
  getModalInfo,
  getTours,
  getReservation,
  saveReservation,
  cancelFactor,
  getTourPassangers,
  addUser,
  payFactor,
};
